import Axios from "axios";
const Config = require("../../config/default.env").default;

export default {
  namespaced: true,
  state: {
    loadingFetch: false,
    loadingCount: false,
    reportCount: 0,
    currentPage: 0,
    reports: [],
  },
  mutations: {
    SET_LOADING_FETCH(state, loading) {
      state.loadingFetch = loading;
    },
    SET_LOADING_COUNT(state, loading) {
      state.loadingCount = loading;
    },
    SET_REPORT_COUNT(state, reportCount) {
      state.reportCount = reportCount;
    },
    ADD_REPORTS(state, reports) {
      state.reports.push(...reports);
    },
  },
  actions: {
    async fetchReportCount({ commit }) {
      commit("SET_LOADING_COUNT", true);
      const url = Config.MS_SOCIOLLA_PUBLIC_API_URL;
      const params = {
        filter: {
          is_active: true,
          is_deleted: false,
          start_date: { $lte: new Date().setHours(23, 59, 59, 999) },
          end_date: { $gte: new Date() },
        },
        sort: "-start_date",
      };
      return Axios.get(`${url}/insight-factory/report/count`, {
        params: params,
      })
        .then((response) => {
          if (response.data) {
            const result = response.data;
            if (result.success) {
              commit("SET_REPORT_COUNT", result.data);
            } else {
              console.log("Count Error", response);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          commit("SET_LOADING_COUNT", false);
        });
    },
    async fetchReports({ commit, state }) {
      const url = Config.MS_SOCIOLLA_PUBLIC_API_URL;
      commit("SET_LOADING_FETCH", true);
      return Axios.get(`${url}/insight-factory/report`, {
        params: {
          skip: state.reports.length > 0 ? state.reports.length : 0,
          limit: 6,
          sort: "-start_date",
          filter: {
            is_active: true,
            is_deleted: false,
            start_date: { $lte: new Date().setHours(23, 59, 59, 999) },
            end_date: { $gte: new Date() },
          },
        },
      })
        .then((response) => {
          if (response.data) {
            const result = response.data;
            if (result.success) {
              commit("ADD_REPORTS", result.data);
            } else {
              console.log("Fetch Error", response);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          commit("SET_LOADING_FETCH", false);
        });
    },
  },
  getters: {},
};
